import { getFormattedPhoneNumber } from 'helpers/formatting';
import { Contact } from 'types/domain';

// Note: The logic in this function must be in sync with "Contact@getNameDisplayAttribute" method in the backend.
const getContactNameDisplay = (
    contact: Pick<Contact, 'first_name' | 'last_name' | 'primary_phone' | 'primary_email'>,
): string => {
    const { first_name, last_name, primary_email, primary_phone } = contact;

    const formattedPhone = primary_phone ? getFormattedPhoneNumber(primary_phone) : null;

    const firstNameDisplay = first_name ?? primary_email ?? formattedPhone ?? '';

    const lastNameDisplay = first_name ? last_name : '';

    return `${firstNameDisplay} ${lastNameDisplay}`.trim();
};

const getContactName = (contact: Pick<Contact, 'first_name' | 'last_name'>): string => {
    return `${contact.first_name ?? ''} ${contact.last_name ?? ''}`.trim();
};

export { getContactNameDisplay, getContactName };
